import React from 'react';

import { EnvironmentOutlined, ShopOutlined, UserOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';

import { AsyncMultiSelect } from 'components/AsyncSelect/AsyncMultiSelect';
import { convertToMultiSelectProps } from 'components/AsyncSelect/useAsyncMultiSelectProps';
import {
  useLocationsSelectProps,
  usePurchasingBuyersSelectProps,
  useSuppliersSelectProps,
} from 'components/AsyncSelect/useAsyncSelectProps';
import { FlexSpace } from 'components/FlexSpace';

import { objRemoveUndefinedValues } from 'utils/object';

import { SearchFrameHashState } from 'types/hash-state';

export const DailyWorkflowFilters = ({
  hashState,
  updateHashState,
}: {
  hashState: SearchFrameHashState;
  updateHashState: (hashState: SearchFrameHashState) => void;
}) => {
  const buyerSelectProps = usePurchasingBuyersSelectProps();
  const suppliersSelectProps = useSuppliersSelectProps();
  const locationsSelectProps = useLocationsSelectProps({});

  return (
    <div
      className={css`
        margin-bottom: 16px;
      `}
    >
      <FlexSpace wrap fullWidth>
        <AsyncMultiSelect
          containerClassName={css`
            width: 100%;
          `}
          popoverClassName={css`
            max-height: 375px;
          `}
          selectProps={convertToMultiSelectProps(buyerSelectProps, { valueKey: 'idName' })}
          label="Buyer"
          queryPlaceholder="Search buyer"
          selectedValues={hashState.where?.buyer || []}
          onSelectedValuesChange={(values) =>
            updateHashState({
              where: objRemoveUndefinedValues({
                ...hashState.where,
                buyer: values,
              }),
            })
          }
          icon={<UserOutlined />}
        />

        <AsyncMultiSelect
          containerClassName={css`
            width: 100%;
          `}
          popoverClassName={css`
            max-height: 335px;
          `}
          selectProps={convertToMultiSelectProps(locationsSelectProps, { valueKey: 'idName' })}
          label="Requirement Location"
          queryPlaceholder="Search locations"
          selectedValues={hashState.where?.location || []}
          onSelectedValuesChange={(values) =>
            updateHashState({
              where: objRemoveUndefinedValues({
                ...hashState.where,
                location: values,
              }),
            })
          }
          icon={<EnvironmentOutlined />}
        />

        <AsyncMultiSelect
          containerClassName={css`
            width: 100%;
          `}
          popoverClassName={css`
            max-height: 295px;
          `}
          selectProps={convertToMultiSelectProps(suppliersSelectProps, { valueKey: 'idName' })}
          label="Supplier"
          queryPlaceholder="Search suppliers"
          selectedValues={hashState.where?.primary_supplier || []}
          onSelectedValuesChange={(values) => {
            updateHashState({
              where: objRemoveUndefinedValues({
                ...hashState.where,
                primary_supplier: values,
              }),
            });
          }}
          icon={<ShopOutlined />}
        />
      </FlexSpace>
    </div>
  );
};
